import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService, AuthCookieService, CommonFunctionsService, DatastoreService } from '../../services';
import { NgxSpinnerService } from "ngx-spinner";
import { PasswordInput } from 'govuk-frontend';
import { B2cService } from '../../services/b2c.service';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.scss']
})
export class AccessComponent implements OnInit {
  @ViewChild('password') passwordCtrl!: ElementRef;

  config: any;
  site: string = "";
  companyDetails: any;

  loginForm: FormGroup;
  passwordResetForm: FormGroup;
  shouldShowPasswordReset: boolean = false;
  resetSubmitted: boolean = false;
  resetSuccess: boolean = false;
  resetPath: string = '';
  resetError: boolean = true;
  loginError: boolean = false;
  loginErrorMessage: string = '';
  showB2c = false;
  loggedInViaSso = false;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private b2c: B2cService,
    private authCookie: AuthCookieService
  ) { }

  get resetForm() { return this.passwordResetForm.controls; }

  get isLoggedInViaCookie(): boolean {
    return this.authCookie.isLoggedIn();
  }

  ngAfterViewInit(): void {
    if (this.passwordCtrl) {
      new PasswordInput(this.passwordCtrl.nativeElement);
    }
  }

  ngOnInit(): void {
    this.loading = true;
    this.buildForm();
    
    this.route.params.subscribe(async params => {
      await this.commonFunctionsService.setCompanyName(params);
      this.site = params.site;
      this.getConfig();
    });
  }

  goToSSOLogin() {
    this.spinner.show();
    this.b2c.sendToAuth();
  }

  async getConfig() {
    this.config = JSON.parse(this.dataStore.config);
    this.companyDetails = await this.apiService.getCompany(this.config.company);
    if (this.config.hasOwnProperty('myCeremony')) {
      if (this.config.myCeremony.hasOwnProperty('access')) {
        if (this.config.myCeremony.access.hasOwnProperty('passwordResetPath')) {
          this.resetPath = `${this.config.myCeremony.access.passwordResetPath}`;
        }
        // b2c
        console.log(this.config.myCeremony.access);
        if (this.config.myCeremony.access.hasOwnProperty('b2c')) {
          this.b2c.set(this.config.myCeremony.access.b2c);
          this.showB2c = true;
          if (this.b2c.decodedToken) {
            this.spinner.show();
            console.log(this.b2c.decodedToken);
            // now we sso
            const ssoToken:any = await this.apiService.generateSSOToken(this.companyDetails.id, this.b2c.decodedToken.given_name, this.b2c.decodedToken.family_name, this.b2c.decodedToken.emails[0]);
            console.log(ssoToken);
            const login:any = await this.apiService.ssoLogin(this.companyDetails.id, ssoToken.token);
            console.log('ssoLogin', login);
            if (login.hasOwnProperty('_embedded') && login._embedded.members.length > 0) {
              const loggedInMember = login._embedded.members[0];
              this.dataStore.authToken = login.auth_token;
              this.dataStore.loginObject = login;
              this.dataStore.member = loggedInMember;

              localStorage.setItem('auth_token', this.dataStore.authToken);
              localStorage.setItem('loginObject', JSON.stringify(this.dataStore.loginObject));

              this.dataStore.loggedIn = true;
              this.authCookie.setLoggedIn();
              this.loggedInViaSso = true;
              console.log('Logged in!');
              this.router.navigate([`${this.commonFunctionsService.getCompanyName()}/${this.commonFunctionsService.getCompanyId()}/our-ceremony`]);
            }
            else {
              this.loginError = true;
              this.loginErrorMessage = 'Unable to log you in.';
            }
          }
          else {
            console.log('no decoded token');
          }
        }
      }
    }
    if (this.resetPath.length < 1) {
      console.warn(`Password reset is unavailable - config.myCeremony.access.passwordResetPath is not set.`);
    }
    else {
      this.buildPasswordResetForm();
    }
    if (!this.loggedInViaSso) {
      this.alreadyLoggedIn();
    }
  }

  logout() {
    this.commonFunctionsService.logout()
    localStorage.clear();
    window.sessionStorage.clear();
    window.location.reload();
  }

  alreadyLoggedIn() {
    const loggedInMemberData = localStorage.getItem('loginObject');
    if (loggedInMemberData) {
      // const loggedInData = JSON.parse(loggedInMemberData);
      // const loggedInMember = loggedInData._embedded.members[0];
      // this.dataStore.authToken = loggedInData.auth_token;
      // this.dataStore.loginObject = loggedInData;
      // this.dataStore.member = loggedInMember;
      // this.dataStore.loggedIn = true;
      // this.router.navigate([`${this.commonFunctionsService.getCompanyName()}/${this.commonFunctionsService.getCompanyId()}/our-ceremony`]);
      this.logout()
    }
    this.loading = false;
  }

  buildForm() {
    this.loginForm = new FormGroup({});
    const emailControl = new FormControl('', [Validators.required, Validators.email]);
    const passwordControl = new FormControl('', [Validators.required]);

    this.loginForm.addControl('email', emailControl);
    this.loginForm.addControl('password', passwordControl);

    this.loginForm.valueChanges.subscribe(values => {
      console.log(values);
      console.log(this.loginForm);
    });
  }

  buildPasswordResetForm() {
    this.passwordResetForm = new FormGroup({});
    const emailControl = new FormControl('', [Validators.required, Validators.email]);
    this.passwordResetForm.addControl('email', emailControl);

    this.passwordResetForm.valueChanges.subscribe(values => {
      console.log(values);
      console.log(this.passwordResetForm);
    });
  }

  toggleResetForm() {
    this.shouldShowPasswordReset = !this.shouldShowPasswordReset;
    this.resetError = false;
    if (this.resetSuccess) {
      this.resetSuccess = false;
    }
    if (this.resetSubmitted) {
      this.resetSubmitted = false;
    }
    this.resetForm.email.reset();
    return false;
  }

  async submit() {
    this.loginError = false;
    this.loginErrorMessage = '';
    if (this.loginForm.valid) {
      const loginData = {
        email: this.loginForm.get('email')?.value,
        password: this.loginForm.get('password')?.value
      };
      try {
        const login = await this.apiService.login(loginData) as any;
        if (login.hasOwnProperty('_embedded') && login._embedded.members.length > 0) {
          const loggedInMember = login._embedded.members[0];
          this.dataStore.authToken = login.auth_token;
          this.dataStore.loginObject = login;
          this.dataStore.member = loggedInMember;

          localStorage.setItem('auth_token', this.dataStore.authToken);
          localStorage.setItem('loginObject', JSON.stringify(this.dataStore.loginObject));

          this.dataStore.loggedIn = true;
          this.authCookie.setLoggedIn();
          this.router.navigate([`${this.commonFunctionsService.getCompanyName()}/${this.commonFunctionsService.getCompanyId()}/our-ceremony`]);
        }
        else {
          this.loginError = true;
          this.loginErrorMessage = 'Your email and/or password was not recognised. Please try again.';
        }
      }
      catch (err) {
        console.error(err);

      }
    }
    else {
      console.log(this.loginForm.controls['email'].errors);
    }
  }

  async submitPasswordReset() {
    this.resetSubmitted = true;
    if (this.passwordResetForm.valid) {
      this.resetSubmitted = false;
      this.resetError = false;
      try {
        const sent: any = await this.apiService.passwordReset(this.resetForm['email'].value, this.config.company, this.resetPath);
        if (sent.result && sent.result === 'Success') {
          this.resetSuccess = true;
        }
        else {
          this.resetError = true;
        }
      }
      catch (err) {
        this.resetError = true;
      }

    }
    else {
      console.log(this.passwordResetForm);
    }
  }

}
